var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8.16602C2.27614 8.16602 2.5 8.38987 2.5 8.66602V13.4993H7.33333C7.60948 13.4993 7.83333 13.7232 7.83333 13.9993C7.83333 14.2755 7.60948 14.4993 7.33333 14.4993H2C1.72386 14.4993 1.5 14.2755 1.5 13.9993V8.66602C1.5 8.38987 1.72386 8.16602 2 8.16602Z",
    fill: "#1A9D39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16602 2C8.16602 1.72386 8.38987 1.5 8.66602 1.5H13.9993C14.2755 1.5 14.4993 1.72386 14.4993 2V7.33333C14.4993 7.60948 14.2755 7.83333 13.9993 7.83333C13.7232 7.83333 13.4993 7.60948 13.4993 7.33333V2.5H8.66602C8.38987 2.5 8.16602 2.27614 8.16602 2Z",
    fill: "#1A9D39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expand-icon.0e664f1e9cc16a863c101140e1fe0895.svg";
export { ForwardRef as ReactComponent };